import { useState } from 'react';

import { EdgeStack } from '@/react/edge/edge-stacks/types';
import { GitReferenceCard } from '@/react/portainer/gitops/GitReferenceCard';
import { isWorkflowManagedStack } from '@/react/common/stacks/isWorkflowManagedStack';

import { GitForm } from './GitForm';
import { HelmRepositoryEditForm } from './HelmRepositoryEditForm';
import { NonGitStackForm } from './NonGitStackForm';

export function EditEdgeStackForm({ edgeStack }: { edgeStack: EdgeStack }) {
  const [hasGitReferenceError, setHasGitReferenceError] = useState(false);

  if (edgeStack.GitConfig) {
    return (
      <>
        {isWorkflowManagedStack(edgeStack) && !!edgeStack.GitSourceId && (
          <div className="mb-4">
            <GitReferenceCard
              stackType={edgeStack.HelmConfig ? 'edge-helm' : 'edge'}
              autoUpdate={edgeStack.AutoUpdate}
              gitConfig={edgeStack.GitConfig}
              currentDeploymentInfo={edgeStack.CurrentDeploymentInfo}
              sourceId={edgeStack.GitSourceId}
              onErrorChange={setHasGitReferenceError}
              workflowId={edgeStack.WorkflowID}
            />
          </div>
        )}
        <GitForm
          stack={edgeStack}
          hasGitReferenceError={hasGitReferenceError}
        />
      </>
    );
  }

  if (edgeStack.HelmConfig?.ChartURL) {
    return <HelmRepositoryEditForm edgeStack={edgeStack} />;
  }

  return <NonGitStackForm edgeStack={edgeStack} />;
}
